module.exports = __webpack_public_path__ + "static/img/checking_logo.29f82425.webp";